module.exports = __webpack_public_path__ + "img/nutrilon-malabsorbciya.023bde1a.png";